import React, { useEffect, useState } from "react"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import { fetchDmPlanningRdv } from "../../../store/actions/depannageDispatchActions"
import { rdvEnRetard } from "./rdvATraiter"
import { DISPATCH_POLL_MS } from "./DepDispatchATraiter"
import DepDispatchATraiter from "./DepDispatchATraiter"
import DepDispatchCamions from "./DepDispatchCamions"
import DepDispatchPlanningMenu from "./DepDispatchPlanningMenu"
import DepDispatchEnCours from "./DepDispatchEnCours"
import DepDispatchAnnulees from "./DepDispatchAnnulees"
import DepPiquetInterrupteur from "./DepPiquetInterrupteur"
import AlerteJoursFeries from "../../others/AlerteJoursFeries"
import DepMissionV2 from "../depmission/DepMissionV2"
import DepDispatchAssistances from "../assistances/DepDispatchAssistances"
import {
	AssistancesProvider,
	PastilleAssistances,
} from "../assistances/AssistancesContext"
import {
	fetchAppels,
	fetchEmployes,
} from "../../../store/actions/depannageActions"
import {
	fetchAutreEntites,
	fetchSecteurs,
} from "../../../store/actions/autreActions"
import { generalStyles as gs } from "../../styles/styles"
import { COLORS } from "../../../utilities/Constants"
import {
	DEPANNAGE_TYPE_APPEL_CHOICES,
	DEP_STATE_DISPATCHED,
	DEP_STATE_EN_SUSPENS,
	DEP_STATE_RENDEZ_VOUS,
} from "../../../utilities/Addons"

// Page /depannage/dispatch (V2) : 4 onglets (À traiter / Planning / En cours /
// Annulées) + création de mission globale — un bouton par type d'appel
// (Assistance / Police / Privé), le modal s'ouvre avec le type déjà posé.
// Chaque onglet gère son propre polling.
// (Les constantes de secteurs ont déménagé dans utilities/secteurs.js — le
// filtre reviendra une fois précisé avec le client.)
const TABS = [
	{ key: 0, label: "À traiter" },
	{ key: 1, label: "Planning" },
	{ key: 2, label: "En cours" },
	{ key: 3, label: "Annulées" },
	// GE-57 : ordres d'assistance (propositions, messages, rapprochements).
	{ key: 4, label: "Assistances" },
]

const ongletDeLaMission = (mission) => {
	const etat = mission && mission.etat
	if (etat >= DEP_STATE_DISPATCHED) return 2
	if (etat === DEP_STATE_RENDEZ_VOUS || etat === DEP_STATE_EN_SUSPENS)
		return 1
	return 0
}

const DepDispatchMenu = () => {
	const dispatch = useDispatch()
	const [factor, setFactor] = useState(0)
	// Type d'appel de la mission en cours de création (DEPANNAGE_TYPE_APPEL_*),
	// null = modal fermé.
	const [newType, setNewType] = useState(null)
	// Bump pour remonter l'onglet À traiter (re-fetch) après une création
	// globale alors qu'on est déjà dessus.
	const [refreshKey, setRefreshKey] = useState(0)
	// B2 (CDC 16.10) : RDV arrivés à leur heure sans dispatch → bandeau sur
	// tous les onglets (RDV relus au sondage, horloge à la minute). Pas de
	// notification serveur pour l'instant (piquet hors horaires : GE-70).
	const { depsRendezVous } = useSelector((s) => s.depannageDispatchInfo)
	const [maintenant, setMaintenant] = useState(() => moment())
	useEffect(() => {
		dispatch(fetchDmPlanningRdv())
		const sondage = setInterval(
			() => dispatch(fetchDmPlanningRdv()),
			DISPATCH_POLL_MS,
		)
		const horloge = setInterval(() => setMaintenant(moment()), 60 * 1000)
		return () => {
			clearInterval(sondage)
			clearInterval(horloge)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	const enRetard = rdvEnRetard(depsRendezVous, maintenant)

	useEffect(() => {
		dispatch(fetchEmployes())
		dispatch(fetchAppels())
		// Mapping secteur géographique ↔ codes postaux (filtre secteur du dispatch).
		dispatch(fetchSecteurs())
		// Référentiel des assistances (filtre « Assistance » du dispatch).
		dispatch(fetchAutreEntites())
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<AssistancesProvider>
			<div style={gs.page}>
				{newType !== null && (
					<DepMissionV2
						visible
						closeModal={() => setNewType(null)}
						refreshDeps={() => {}}
						appelTypeInitial={newType}
						onSaved={(mission) => {
							// A15 (CDC 16.10) : bascule sur l'onglet où la
							// mission apparaît — dispatchée (« Créer et
							// dispatcher ») → En cours ; planifiée / en
							// suspens → Planning ; sinon À traiter.
							setFactor(ongletDeLaMission(mission))
							setRefreshKey((k) => k + 1)
						}}
					/>
				)}

				<div style={st.header}>
					<div style={{ ...gs.title, marginBottom: 0 }}>
						Dispatch dépannage
					</div>
					{/* Création directe : un bouton par type d'appel, groupés sous
				    l'étiquette « Nouvelle mission » (même traitement sombre que
				    le bouton primaire qu'ils remplacent). */}
					<div
						style={st.newGroup}
						role="group"
						aria-label="Nouvelle mission"
					>
						<span style={st.newLabel}>Nouvelle mission</span>
						{DEPANNAGE_TYPE_APPEL_CHOICES.map((t, i) => (
							<React.Fragment key={`new_${t[0]}`}>
								{i > 0 && <span style={st.newSep} />}
								<button
									type="button"
									style={st.newBtn}
									onClick={() => setNewType(t[0])}
								>
									{t[1]}
								</button>
							</React.Fragment>
						))}
					</div>
				</div>

				{/* GE-47 : interrupteur du dispatch de piquet (poll interne). */}
				<DepPiquetInterrupteur />
				{/* B9 : fériés de l'année (ou de la suivante) non générés. */}
				<AlerteJoursFeries />
				{enRetard.length > 0 && (
					<div style={st.alerteRdv} role="alert">
						<span>
							{`⚠ ${enRetard.length} rendez-vous à l'heure sans dispatch (${enRetard
								.slice(0, 3)
								.map(
									({ dm, date }) =>
										`${date.format(
											date.isSame(maintenant, "day")
												? "HH:mm"
												: "DD.MM HH:mm",
										)} ${`${dm.marque} ${dm.plaques || ""}`.trim()}`,
								)
								.join(
									" · ",
								)}${enRetard.length > 3 ? " …" : ""})`}
						</span>
						<button
							type="button"
							style={st.alerteRdvBtn}
							onClick={() => setFactor(1)}
						>
							Voir dans le planning
						</button>
					</div>
				)}

				{/* Bandeau temps réel : qui tient quel camion (visible sur tous
			    les onglets — poll géré par le composant). */}
				<DepDispatchCamions />

				<div style={{ ...gs.segmented, margin: "16px 0" }}>
					{TABS.map((t) => (
						<button
							key={`tab_${t.key}`}
							type="button"
							style={gs.segment(factor === t.key)}
							onClick={() => setFactor(t.key)}
						>
							{t.label}
							{t.key === 4 && <PastilleAssistances />}
						</button>
					))}
				</div>

				{factor === 0 && (
					<DepDispatchATraiter key={`atraiter_${refreshKey}`} />
				)}
				{factor === 1 && <DepDispatchPlanningMenu />}
				{factor === 2 && <DepDispatchEnCours />}
				{factor === 3 && <DepDispatchAnnulees />}
				{factor === 4 && <DepDispatchAssistances />}
			</div>
		</AssistancesProvider>
	)
}

const st = {
	alerteRdv: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 12,
		flexWrap: "wrap",
		marginTop: 16,
		padding: "10px 14px",
		borderRadius: 12,
		border: `1px solid ${COLORS.dangerBorder}`,
		background: COLORS.dangerLight,
		color: COLORS.danger,
		fontSize: 13,
		fontWeight: 600,
	},
	alerteRdvBtn: {
		border: `1px solid ${COLORS.dangerBorder}`,
		background: COLORS.surface,
		color: COLORS.danger,
		borderRadius: 10,
		padding: "6px 12px",
		fontWeight: 600,
		fontFamily: "inherit",
		cursor: "pointer",
	},
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 16,
	},
	newGroup: {
		display: "inline-flex",
		alignItems: "center",
		backgroundColor: COLORS.text,
		borderRadius: 10,
		overflow: "hidden",
	},
	newLabel: {
		padding: "0 6px 0 16px",
		fontSize: 12,
		fontWeight: 600,
		color: "rgba(255, 255, 255, 0.55)",
		whiteSpace: "nowrap",
	},
	newBtn: {
		padding: "10px 16px",
		border: "none",
		backgroundColor: "transparent",
		color: "#fff",
		fontSize: 14,
		fontWeight: 500,
		cursor: "pointer",
		fontFamily: "inherit",
		whiteSpace: "nowrap",
	},
	newSep: {
		width: 1,
		height: 16,
		backgroundColor: "rgba(255, 255, 255, 0.25)",
	},
}

export default DepDispatchMenu
